import { Component } from 'preact';
import { Coffee } from 'lucide-react';
import { UI } from '../utils/arena/uiSounds';
import { isWeb } from '../utils/platform';
import {
  VIGNETTE, TEXT_PRIMARY, TEXT_BODY, TEXT_MUTED, PANEL_BG, BEVELED_BTN,
  GOLD,
  DANGER_BTN, FourCorners, OrnamentalDivider, MenuButton,
} from '../lib/medievalTheme';
import ReportIssueDialog from './ReportIssueDialog';
import BetaBadge from './BetaBadge';
import { t } from '../localization/t';

const SUPPORT_URL = 'https://buymeacoffee.com/clutterfox';

export default class GameMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { confirmMainMenu: false, showReport: false };
  }

  handleMainMenuClick = () => {
    if (this.props.inSession) {
      this.setState({ confirmMainMenu: true });
    } else {
      this.props.onMainMenu?.();
    }
  };

  confirmMainMenu = () => {
    this.setState({ confirmMainMenu: false });
    this.props.onMainMenu?.();
  };

  cancelMainMenu = () => this.setState({ confirmMainMenu: false });

  render() {
    const { onResume, onQuit, onOpenSettings, onMainMenu, appVersion } = this.props;
    const { confirmMainMenu, showReport } = this.state;

    return (
      <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center" style={{ background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)' }}>
        <div className="fixed inset-0 pointer-events-none" style={{ background: VIGNETTE }} />
        <div className="relative w-80 mb-12">
          <img src="/valkenhall-logo.png" alt="Valkenhall" className="relative w-full" draggable={false} />
          <BetaBadge />
        </div>
        <div className="flex flex-col gap-1 w-64 relative">
          <MenuButton title={t('Resume')} onClick={onResume} />
          <MenuButton title={t('Settings')} onClick={onOpenSettings} />
          <MenuButton title={t('Report Issue')} onClick={() => this.setState({ showReport: true })} />
          {onMainMenu ? <MenuButton title={t('Main Menu')} onClick={this.handleMainMenuClick} /> : null}
          {/* No process to quit in a browser; the tab close button is the quit. */}
          {isWeb() ? null : (
            <>
              <OrnamentalDivider className="my-2" />
              <button
                type="button"
                className="relative w-full py-3 text-sm font-semibold arena-heading cursor-pointer transition-all"
                style={{ ...DANGER_BTN, borderRadius: 'var(--radius-md)' }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(180,60,60,0.55)'; e.currentTarget.style.transform = 'scale(1.02)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(180,60,60,0.35)'; e.currentTarget.style.transform = 'scale(1)'; }}
                data-sound={UI.CANCEL}
                onClick={onQuit}
              >
                {t('Quit Game')}
              </button>
            </>
          )}
        </div>

        <div className="w-64 mt-3 relative">
          <MenuButton
            title={t('Support Development')}
            icon={<Coffee style={{ width: '0.875cqw', height: '0.875cqw' }} />}
            href={SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            compact
          />
        </div>

        {showReport ? (
          <ReportIssueDialog
            appVersion={appVersion}
            onClose={() => this.setState({ showReport: false })}
          />
        ) : null}

        {confirmMainMenu ? (
          <div className="fixed inset-0 z-[210] flex items-center justify-center" style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}>
            <div className="relative w-80 p-5" style={{ background: PANEL_BG, border: `1px solid ${GOLD} 0.25)`, borderRadius: 'var(--radius-xl)', boxShadow: '0 0 60px rgba(0,0,0,0.5)', isolation: 'isolate' }}>
              <FourCorners />
              <h2 className="mb-2 text-lg font-semibold arena-heading" style={{ color: TEXT_PRIMARY }}>{t('Return to main menu?')}</h2>
              <p className="mb-4 text-sm" style={{ color: TEXT_MUTED }}>{t('Your game will be auto-saved and the session will end.')}</p>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium cursor-pointer transition-all"
                  style={{ ...BEVELED_BTN, color: TEXT_BODY, borderRadius: 'var(--radius-md)' }}
                  data-sound={UI.CANCEL}
                  onClick={this.cancelMainMenu}
                >
                  {t('Cancel')}
                </button>
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium cursor-pointer transition-all"
                  style={{ ...DANGER_BTN, borderRadius: 'var(--radius-md)' }}
                  data-sound={UI.CONFIRM}
                  onClick={this.confirmMainMenu}
                >
                  {t('Main Menu')}
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
